import { render, staticRenderFns } from "./CompetitionsPanel.vue?vue&type=template&id=f98e381e&"
import script from "./CompetitionsPanel.vue?vue&type=script&lang=js&"
export * from "./CompetitionsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports